import React from 'react';

const ImageItem = ({ image }) => {
  return (
    <React.Fragment>
      {image && image.url && (
        <img
          src={image.url}
          alt=""
          loading="lazy"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      )}
    </React.Fragment>
  );
};

export default ImageItem;
